import React from "react";

interface AddRecordPanelProps {
  /** Caption above the dashed box, e.g. "Add new chemical record". */
  label: string;
  /** Draws the dashed separator only when the list above is non-empty. */
  hasRecords: boolean;
  children: React.ReactNode;
}

/** Dashed "add a new record" panel shown at the bottom of a record list. */
const AddRecordPanel: React.FC<AddRecordPanelProps> = ({ label, hasRecords, children }) => (
  <>
    {hasRecords && <div className="tw-border-t tw-border-dashed tw-border-border" />}
    <div className="tw-space-y-2">
      <p className="tw-text-[10px] tw-text-muted-foreground">{label}</p>
      <div className="tw-border tw-border-dashed tw-border-primary/30 tw-rounded-md tw-p-3 tw-bg-primary/5">
        {children}
      </div>
    </div>
  </>
);

export default AddRecordPanel;
